import { render, staticRenderFns } from "./Lagerwerte.vue?vue&type=template&id=e8d7ca4c&"
import script from "./Lagerwerte.vue?vue&type=script&lang=js&"
export * from "./Lagerwerte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports